import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@cgn/framework-ui-components/v2';
import BottoneAttivaPianiEccellenza from '../shared/BottoneAttivaPianiEccellenza';
import BottoneScopriPianiEccellenza from '../shared/BottoneScopriPianiEccellenza';
import usePianoEccellenza, { StatoCategoriaPDE, StatoUfficioPDE } from '../../Shared/Profilo/usePianoEccellenza';

const FooterSceltaServizio = ({
  onAvantiClick, codiceUfficio, servizio, categoria,
}) => {
  const {
    statoUfficio,
    statoCategoria,
  } = usePianoEccellenza(codiceUfficio, servizio, categoria);

  if (statoUfficio === StatoUfficioPDE.NON_INTERESSATO_DA_PDE) {
    return (
      <Button
        emphasis={Button.Emphasis.HIGH}
        onClick={onAvantiClick}
        primary
      >
        Avanti
      </Button>
    );
  }

  if (statoCategoria === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA
    && statoUfficio === StatoUfficioPDE.PIANO_QUALITA
  ) {
    return (
      <>
        <BottoneScopriPianiEccellenza codiceUfficio={codiceUfficio} />
        <BottoneAttivaPianiEccellenza codiceUfficio={codiceUfficio} />
      </>
    );
  }

  let disabled = false;
  if (statoCategoria === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA && statoUfficio === StatoUfficioPDE.PDE_SOSPESO) {
    disabled = true;
  } else if (!servizio || !categoria) {
    disabled = true;
  }

  return (
    <Button
      disabled={disabled}
      emphasis={Button.Emphasis.HIGH}
      onClick={onAvantiClick}
      primary
    >
      Avanti
    </Button>
  );
};

FooterSceltaServizio.propTypes = {
  onAvantiClick: PropTypes.func.isRequired,
  servizio: PropTypes.shape({
    IdServizio: PropTypes.number,
    Alias: PropTypes.string,
  }),
  categoria: PropTypes.shape({
    IdCategoria: PropTypes.number,
    IdCategoriaPadre: PropTypes.number,
    InfoEvasione: PropTypes.string,
    EsclusivaEccellenza: PropTypes.bool,
    argomenti: PropTypes.arrayOf({
      IdCategoria: PropTypes.number,
      IdCategoriaPadre: PropTypes.number,
    }),
  }),
  codiceUfficio: PropTypes.string,
};

FooterSceltaServizio.defaultProps = {
  servizio: undefined,
  categoria: undefined,
  codiceUfficio: undefined,
};

export default FooterSceltaServizio;
